const initialState = [];
export const getInitialState = () => initialState;
//# sourceMappingURL=initialState.js.map